import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Heart, User, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export function SeekerCard({ seeker, saved }) {
  const nav = useNavigate();
  const { requireAuth } = useAuth();
  const [isSaved, setIsSaved] = useState(saved);
  const d = seeker.data || {};
  const photo = seeker.images && seeker.images[0];
  const jobType = (d.job_types || [])[0];

  const toggle = (e) => {
    e.stopPropagation();
    requireAuth(async () => {
      try { const r = await api.post(`/favorites/${seeker.id}`); setIsSaved(r.data.saved); toast.success(r.data.saved ? "U ruajt" : "U hoq"); }
      catch { toast.error("Gabim"); }
    });
  };

  return (
    <div data-testid={`seeker-card-${seeker.id}`} onClick={() => nav(`/punekerkues/${seeker.id}`)} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 flex flex-col items-center text-center hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer gs-fade relative">
      <button data-testid={`save-seeker-${seeker.id}`} onClick={toggle} className="absolute top-3 right-3 bg-slate-50 hover:bg-slate-100 rounded-full p-1.5">
        <Heart className={`w-4 h-4 ${isSaved ? "fill-red-500 text-red-500" : "text-slate-400"}`} />
      </button>
      <div className="w-20 h-20 rounded-full overflow-hidden ring-2 ring-amber-100 bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center text-white text-2xl font-bold">
        {photo ? <img src={photo} alt={seeker.title} loading="lazy" decoding="async" className="w-full h-full object-cover" /> : (seeker.title?.[0]?.toUpperCase() || <User className="w-8 h-8" />)}
      </div>
      <h3 className="font-bold text-slate-800 text-sm mt-2 line-clamp-1">{seeker.title}</h3>
      <p className="text-amber-600 font-semibold text-xs line-clamp-1">{seeker.subcategory}</p>
      <div className="flex items-center gap-1 text-xs text-slate-400 mt-1"><MapPin className="w-3 h-3" />{seeker.city}</div>
      {(jobType || d.experience_level) && (
        <div className="flex flex-wrap items-center justify-center gap-1 mt-2">
          {jobType && <span className="text-[10px] bg-yellow-100 text-yellow-700 font-semibold px-2 py-0.5 rounded-full flex items-center gap-0.5"><Clock className="w-2.5 h-2.5" />{jobType}</span>}
          {d.experience_level && <span className="text-[10px] bg-slate-100 text-slate-600 font-semibold px-2 py-0.5 rounded-full">{d.experience_level}</span>}
        </div>
      )}
      <button data-testid={`view-seeker-${seeker.id}`} className="mt-3 w-full bg-amber-50 text-amber-700 font-semibold text-sm rounded-xl py-2">Shiko profilin</button>
    </div>
  );
}

export default SeekerCard;
